import type { ApiClient } from '../client';
import { LockerLogSchema, type LockerLog } from '../schemas/lockerLog';

// Read the activity log of a «buzón», by BOX id (contract update 2026-07-27: the log is read
// box-first, not by delivery id — the caller resolves the box from the delivery detail's `box.id`).
// The resource is `boxes` — the contract's original spelling was a backend typo (fixed 2026-07-28,
// ledger AS-032). A box with no history is an empty log; a missing box is `404 box_not_found`.
// The id rides the path (url-encoded); the client attaches the Firebase token via the
// Authorization header. The response is grouped by box↔lock pairing period; the schema flattens it.
export async function fetchLockerLog(client: ApiClient, boxId: string): Promise<LockerLog> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/boxes/${encodeURIComponent(boxId)}/logs`,
  );
  return LockerLogSchema.parse(data);
}
